import NodeStatus from 'features/Integrations/components/NodeStatus/NodeStatus';
import { usePerms } from 'contexts/PermsContext';
import dayjs from 'dayjs';
import { hasDevicePermissionFromDevice } from 'features/Integrations/features/ConnectedSystems/utils/devicePermissions.utils';
import {
  openStageSettings,
  openDeviceSettings,
  openUSGSSettings,
} from 'features/Integrations/state/slices/deviceSlice';
import { DeviceIsSystemType } from 'features/Integrations/utils/deviceComparison.utils';
import { getDeviceIndexMap, getDeviceLicenseInfo } from 'features/Integrations/utils/license.utils';
import { FaCog } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useGetConnectedDevicesQuery } from 'services/devices/devices.api';
import { useGetLicenseInfoQuery } from 'services/integrations/integrations.api';
import { getDynamicDeviceIcon } from 'utils/devices/icon.utils';

export const DeviceRow = ({ deviceId, last, hideDate = false }) => {
  const { data: connectedDevices = [] } = useGetConnectedDevicesQuery();
  const { data: licenseInfo = {} } = useGetLicenseInfoQuery();
  const perms = usePerms();
  const dispatch = useDispatch();
  const deviceIndex = connectedDevices?.findIndex((device) => device.id === deviceId);

  const device = deviceIndex >= 0 ? connectedDevices[deviceIndex] : null;
  if (!device) return null;
  const deviceIndexMap = getDeviceIndexMap(connectedDevices);
  const license = getDeviceLicenseInfo(device, licenseInfo);
  const canEditDevice = hasDevicePermissionFromDevice(perms, device, 'createEdit');
  const deviceIcon = getDynamicDeviceIcon(device, 'img', [30, 30]);

  // Compact layout when date column is hidden (used in group dropdowns).
  const nameColClass = hideDate ? 'col-12 col-md-4 col-lg-5' : 'col-12 col-md-4 col-lg-3';
  const statusColClass = hideDate ? 'col-12 col-md-3 col-lg-4' : 'col-12 col-md-2 col-lg-2';
  const dateColClass = 'col-12 col-md-2 col-lg-3';
  const cogColClass = hideDate
    ? 'col-12 col-md-2 col-lg-1 d-flex justify-content-md-end'
    : 'col-12 col-md-1 col-lg-2 d-flex justify-content-md-end';

  const onSettingsClick = (e) => {
    e.stopPropagation();
    if (DeviceIsSystemType(device, 'Flood')) {
      dispatch(openStageSettings(device.id));
    } else if (device.system_type === 'USGS') {
      dispatch(openUSGSSettings(device.id));
    } else {
      dispatch(openDeviceSettings(device.id));
    }
  };

  return (
    <div
      className={`row py-2 px-2 g-2 align-items-center ${
        last ? '' : 'border-bottom border-secondary'
      }`}
    >
      <div className={nameColClass}>
        <div className="d-flex align-items-center gap-3">
          <div>
            <img src={deviceIcon} alt={device?.device_type || 'Device'} width={'30px'} />
          </div>
          <div>
            <p className="m-0">
              {device?.alias || device?.monitoring_location_name || device?.name}
            </p>
            <p className="d-none d-lg-block m-0 text-secondary">{device?.name}</p>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-3 col-lg-2">
        {license && <p>{`${license.remaining} of ${license.limit} (Licenses remaining)`}</p>}
      </div>
      <div className={statusColClass}>
        <NodeStatus device={device} />
      </div>
      {!hideDate && (
        <div className={dateColClass}>
          <p>{dayjs(device?.date_created).format('MM/DD/YYYY, hh:mm:ss A')}</p>
        </div>
      )}
      {canEditDevice ? (
        <div className={cogColClass}>
          <div onClick={onSettingsClick}>
            <FaCog size={22} />
          </div>
        </div>
      ) : (
        <div className={cogColClass.split(' d-flex')[0]} />
      )}
    </div>
  );
};
